import { TFunction } from 'i18next'

import { AnalystLegacyPlotLabels } from './analystChartAdapters'

/**
 * The chrome a stored analyst chart or table read prints, in the viewer's UI
 * language (stored exhibits carry none). One list for the analyst chart and
 * the featured table.
 */
export function analystLegacyPlotLabels(t: TFunction<'app'>): AnalystLegacyPlotLabels {
  return {
    plot_no_data: t('studyReport.numericChart.noData'),
    plot_low_base: t('studyReport.numericChart.lowBase'),
    too_close_to_call: t('studyReport.tooCloseToCall'),
    unsupported_rating_scale: t('studyReport.plotNotAvailable'),
  }
}
